import { useContext } from "react";
import { ModalContext } from "../context/ModalContext";
import { SVGS } from ".";
import { HSOverlay } from "preline";

const Modal = () => {
  const { modal } = useContext(ModalContext);
  const actionClasses =
    modal?.actionType === "delete"
      ? "bg-red-600 hover:bg-red-700 "
      : "bg-teal-500 hover:bg-teal-600";
  return (
    <>
      <div
        id="hs-slide-up-animation-modal"
        className={`hs-overlay hidden size-full fixed top-0 start-0 z-[1000] overflow-x-hidden overflow-y-auto pointer-events-none`}
      >
        <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-14 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto">
            <div className="flex justify-between items-center py-3 px-4 border-b">
              <h3 className="font-bold text-gray-800">
                {modal?.content?.eventName}
              </h3>

              <button
                type="button"
                className="hs-dropup-toggle flex justify-center items-center size-7 text-sm font-semibold rounded-full border border-transparent text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none"
                data-hs-overlay="#hs-slide-up-animation-modal"
              >
                <span className="sr-only">Odustani</span>
                <svg
                  className="flex-shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18"></path>
                  <path d="m6 6 12 12"></path>
                </svg>
              </button>
            </div>
            <div className="p-4 overflow-y-auto">
              <p className="mt-1 text-gray-800">{modal?.content?.text}</p>
            </div>
            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t">
              <button
                type="button"
                className="hs-dropup-toggle py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                data-hs-overlay="#hs-slide-up-animation-modal"
              >
                Odustani
              </button>
              <button
                type="button"
                onClick={modal?.onConfirm}
                className={`hs-dropup-toggle py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-white disabled:opacity-50 disabled:pointer-events-none ${actionClasses}`}
                data-hs-overlay="#hs-slide-up-animation-modal"
              >
                {modal?.actionType === "delete" ? "Izbrisi" : "Azuriraj"}

                {modal?.actionType === "delete" ? (
                  <SVGS.DeleteSVG />
                ) : (
                  <SVGS.CheckmarkSVG />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
